import { Box, Link, Typography } from "@mui/material";
import { StarRating } from "components/rating";
import { useTemplate } from "containers/templateDetail/store";
import * as React from "react";

export default function ReviewScore(): React.ReactElement {
  const { review } = useTemplate();

  return (
    <Link sx={{ display: "flex", mt: 1.5 }} href="#reviews" underline="hover">
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <StarRating defaultValue={review?.score || 5} readOnly />
        {review?.quantity > 0 && (
          <Typography sx={{ ml: 2 }} variant="body2" component="span">
            {review?.quantity || 0} Reviews
          </Typography>
        )}
      </Box>
    </Link>
  );
}
